module.exports = __webpack_public_path__ + "img/img-header.52e99ab2.png";